import React from 'react';
import { Loader2, Trash2 } from 'lucide-react';
import EmailThreadRow from './EmailThreadRow';
import { fmtDate, extractName } from './emailUtils';

// Threads / drafts list body with empty states + pagination button.
export default function EmailThreadList({
  loadingList, folder, drafts, visibleThreads, totalThreads,
  selectedThreadId, selectedThreadIds, selectedAccount,
  nextPageToken, loadingMore,
  onOpenThread, onToggleSelect, onToggleStar, onQuickTrash,
  onOpenDraft, onDeleteDraft, onLoadMore,
}) {
  if (loadingList && totalThreads === 0 && drafts.length === 0) {
    return (
      <div className="py-10 flex items-center justify-center text-[#8E8FA5] text-[13px]">
        <Loader2 className="w-4 h-4 animate-spin mr-2" /> Chargement…
      </div>
    );
  }

  if (folder === 'DRAFT') {
    if (drafts.length === 0) {
      return <div className="py-10 text-center text-[13px] text-[#8E8FA5]">Aucun brouillon.</div>;
    }
    return drafts.map((d) => (
      <div
        key={d.draft_id}
        className="w-full text-left px-4 py-3 border-b border-[#F3F4F8] hover:bg-[#FAFAFE] cursor-pointer"
        onClick={() => onOpenDraft(d.draft_id)}
        data-testid={`email-draft-${d.draft_id}`}
      >
        <div className="flex items-baseline justify-between gap-2">
          <span className="text-[12.5px] font-medium text-[#4A4B63] truncate">
            {d.to ? `À : ${extractName(d.to)}` : <span className="italic text-[#8E8FA5]">(Pas de destinataire)</span>}
          </span>
          <span className="text-[10.5px] text-[#8E8FA5] flex-shrink-0">{fmtDate(d.date_ms)}</span>
        </div>
        <div className="text-[12.5px] font-semibold text-[#1A1B2E] truncate mt-0.5">
          {d.subject || <span className="italic font-normal text-[#8E8FA5]">(Sans objet)</span>}
        </div>
        <div className="flex items-start justify-between gap-2 mt-0.5">
          <div className="text-[11.5px] text-[#8E8FA5] truncate flex-1">{d.snippet}</div>
          <button
            onClick={(e) => { e.stopPropagation(); onDeleteDraft(d.draft_id); }}
            className="text-[#B91C1C] opacity-60 hover:opacity-100 flex-shrink-0"
            title="Supprimer"
          ><Trash2 className="w-3.5 h-3.5" /></button>
        </div>
      </div>
    ));
  }

  if (visibleThreads.length === 0) {
    return (
      <div className="py-10 text-center text-[13px] text-[#8E8FA5]">
        {totalThreads === 0 ? 'Aucun message dans ce dossier.' : 'Aucun message ne correspond à ce filtre.'}
      </div>
    );
  }

  return (
    <>
      {visibleThreads.map((t) => (
        <EmailThreadRow
          key={t.thread_id}
          t={t}
          selected={selectedThreadId === t.thread_id}
          checked={selectedThreadIds.has(t.thread_id)}
          showAccount={selectedAccount === '__all__'}
          onOpen={onOpenThread}
          onToggleSelect={onToggleSelect}
          onToggleStar={onToggleStar}
          onQuickTrash={onQuickTrash}
        />
      ))}
      {nextPageToken && selectedAccount !== '__all__' && (
        <div className="p-3 text-center border-t border-[#EFF0F6]">
          <button
            type="button"
            onClick={onLoadMore}
            disabled={loadingMore}
            data-testid="email-load-more"
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#F6F7FB] hover:bg-[#EEF2FF] border border-[#EFF0F6] text-[12px] font-semibold text-[#4F46E5] disabled:opacity-60 disabled:cursor-wait"
          >
            {loadingMore ? 'Chargement…' : `Charger 100 messages de plus (${totalThreads} affichés)`}
          </button>
        </div>
      )}
    </>
  );
}
